import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: { defaultMessage: 'Not allowed' },
  description: { defaultMessage: 'You are not enabled to perform this action' },
});
